import useWindowSize from '~/js/hooks/use-window-size';
import { addClass, removeClass } from '~/js/utils/class-management';

function createWidgetFixedOnScroll(widgetWrap: HTMLDivElement) {
  if (!useWindowSize().isDesktop) return;

  window.scrollTo(0, 0);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const footer = document.querySelector('footer') as HTMLElement;

  const { top: footerTop } = footer.getBoundingClientRect();

  const { top: widgetTop, height: widgetHeight } =
    widgetWrap.getBoundingClientRect();

  const spaceTop = footerTop - widgetHeight;

  window.addEventListener('scroll', () => {
    const top = window.scrollY;

    if (top >= widgetTop && top <= spaceTop) {
      Object.assign(widgetWrap.style, { position: 'fixed', top: '12px' });
      addClass(widgetWrap, 'is-scrolling');
    } else if (top > spaceTop) {
      Object.assign(widgetWrap.style, {
        position: 'absolute',
        top: `${spaceTop - widgetHeight / 2}px`,
      });
      removeClass(widgetWrap, 'is-scrolling');
    } else {
      widgetWrap.removeAttribute('style');
      removeClass(widgetWrap, 'is-scrolling');
    }
  });
}

export default createWidgetFixedOnScroll;
